import React from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { PermissaoEnum } from '../model/Usuario/Permissao';
import RouteGuard from '../services/RouteGuard';
import useUserStore from '../stores/userStore';
import AuditoriaPage from '../view/Auditoria';
import ConsultarDisponibilidadeBanca from '../view/Bancas/ConsultarDisponibilidade';
import DefinirMembrosBanca from '../view/Bancas/DefinirBanca';
import Bancas from '../view/Bancas';
import CandidatosUpload from '../view/Candidato/CandidatosUpload';
import SolicitacoesAlteracaoSensivelPage from '../view/Candidato/SolicitacoesAlteracaoSensivelPage';
import EmailCandidatosHeteroidentificacao from '../view/Candidato/Emails/EmailCandidatosHeteroidentificacao';
import FormularioRecurso from '../view/Candidato/FormularioRecurso';
import RecursosPage from '../view/Candidato/RecursosPage';
import SelecionarBancaRecursosPendentes from '../view/Candidato/SelecionarBancaRecursosPendentes';
import ConfirmaEmail from '../view/ConfirmaEmail';
import PaginaCronograma from '../view/Cronograma';
import Home from '../view/Home';
import Login from '../view/Login';
import PaginaAcessoNegado from '../view/PaginaAcessoNegado';
import MembrosCavuPage from '../view/Pessoas/MembrosCavu/MembrosCavuPage';
import ProcessosNova from '../view/Processos';
import Root from '../view/Root';
import DefinirSalaEspera from '../view/SalaEspera';
import BancasTecnicoPage from '../view/Tecnico/bancasTecnicoPage';
import UnidadeCadastro from '../view/Unidades';
import UnidadeEdicao from '../view/Unidades/UnidadeEdicao';
import GerenciarPerfis from '../view/Usuarios/GerenciarCredenciados';
import PermissoesPerfis from '../view/Usuarios/PermissoesPerfis';
import { BreadcrumbProvider } from './BreadcrumbContext';
import ProcessoWrapper from './ProcessoWrapper';


import ExternosPage from '@/view/Pessoas/Externos/ExternosPage';
import Composicoes from '../view/Composicoes';
import NovoTemplate from '../view/Composicoes/Novo';
import DetalhesComposicao from '../view/Composicoes/Detalhes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/toast-custom.css';
import AuditoriaVotacao from '../view/Auditoria/AuditoriaVotacao';
import VincularCandidatosBanca from '../view/Bancas/Candidatos/VincularCandidatosBanca';
import ComposicaoBancaDetalhada from '../view/Bancas/ComposicaoBancaDetalhada';
import CandidateSearchPage from '../view/Candidato/CandidateSearchPage';
import CandidatosEdicao from '../view/Candidato/CandidatoEdicao';
import CandidatosProcesso from '../view/Candidato/CandidatoProcesso/CandidatosProcesso';
import CandidatosBancaPage from '../view/Candidato/CandidatosBanca/CandidatosBancaPage';
import CandidatosBancaVideo from '../view/Candidato/CandidatosBanca/CandidatosBancaVideo';
import AcessoSalaCandidato from '../view/Candidato/AcessoSalaCandidato';
import ContaServicoPage from '../view/ContaServico/ContaServicoPage';
import SolicitarContaServicoPage from '../view/ContaServico/SolicitarContaServicoPage';
import MinhasContasServicoPage from '../view/ContaServico/MinhasContasServicoPage';
import { CronogramaGeral } from '../view/Cronograma/CronogramaGeral';
import CronogramaPDF from '../view/Cronograma/CronogramaPDF';
import VotacaoMembro from '../view/Votacao/VotacaoMembro';
import VotacaoPresidente from '../view/Votacao/VotacaoPresidente';
import VotacaoAdmin from '../view/Votacao/VotacaoAdmin';
import IntegracaoSigaLogs from '../view/IntegracaoSigaLogs';
import SigaDac from '../view/SigaDac';
import VerificacaoDocumento from '../view/VerificacaoDocumento';
import Changelog from '../view/Changelog';
import AcessoCandidatoConfiguracoesPage from '../view/Configuracoes/AcessoCandidatoConfiguracoesPage';
import ConfiguracaoFotoPage from '../view/Configuracoes/ConfiguracaoFotoPage';
import PaginasPublicas from '../view/PaginasPublicas';
import AdminVideoRecoveryPage from '../view/Admin/AdminVideoRecoveryPage';
import ApiDocsPage from '../view/ApiDocs';

const AppRouter: React.FC = () => {
    const { usuario } = useUserStore();

    return (
        <Router>
            <BreadcrumbProvider>
                <Routes>
                    {/* Rotas públicas - não requerem autenticação */}
                    <Route path="/historico/candidatos" element={<CandidateSearchPage />} />
                    <Route path="/emails/confirmacao" element={<ConfirmaEmail />} />
                    <Route path="/email/confirmacao" element={<ConfirmaEmail />} />
                    <Route path="/recurso" element={<FormularioRecurso />} />
                    <Route path="/recursos/candidato" element={<FormularioRecurso />} />
                    <Route path="/candidato" element={<AcessoSalaCandidato />} />
                    <Route path="/verificacao" element={<VerificacaoDocumento />} />
                    <Route path="/verificacao/:codigo" element={<VerificacaoDocumento />} />
                    <Route path="/login" element={<Login />} />
                    {/* Rotas protegidas - cada página se protege individualmente */}
                    <Route path="/" element={<Root />}>
                        <Route path="/contas-servico" element={
                            <RouteGuard
                                routeTo={<ContaServicoPage />}
                                requiredPermissoes={[PermissaoEnum.ADMINISTRADOR]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/contas-servico/solicitar" element={<SolicitarContaServicoPage />} />
                        <Route path="/contas-servico/minhas" element={<MinhasContasServicoPage />} />
                        <Route path="/cronograma" element={
                            <RouteGuard
                                routeTo={<CronogramaGeral />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_CRONOGRAMA]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/cronograma-pdf" element={
                            <RouteGuard
                                routeTo={<CronogramaPDF />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_CRONOGRAMA]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/processos/:processoId/bancas/:bancaId/recursos" element={
                            <RouteGuard
                                routeTo={<RecursosPage />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_RECURSO]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/processos/:processoId/candidatos/editar" element={
                            <RouteGuard
                                routeTo={<CandidatosEdicao />}
                                requiredPermissoes={[PermissaoEnum.EDITAR_CANDIDATO]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/auditoria" element={
                            <RouteGuard
                                routeTo={<AuditoriaPage />}
                                requiredPermissoes={[PermissaoEnum.AUDITORIA]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/auditoria-heteroidentificacao" element={
                            <RouteGuard
                                routeTo={<AuditoriaVotacao />}
                                requiredPermissoes={[PermissaoEnum.VINCULAR_CANDIDATO]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/integracao-siga/logs" element={
                            <RouteGuard
                                routeTo={<IntegracaoSigaLogs />}
                                requiredPermissoes={[PermissaoEnum.ADMINISTRADOR]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/configuracoes/acesso-candidato" element={
                            <RouteGuard
                                routeTo={<AcessoCandidatoConfiguracoesPage />}
                                requiredPermissoes={[PermissaoEnum.ADMINISTRADOR]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/configuracoes/foto" element={
                            <RouteGuard
                                routeTo={<ConfiguracaoFotoPage />}
                                requiredPermissoes={[PermissaoEnum.ADMINISTRADOR]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/candidatos/solicitacoes-sensiveis" element={
                            <RouteGuard
                                routeTo={<SolicitacoesAlteracaoSensivelPage />}
                                requiredPermissoes={[PermissaoEnum.ADMINISTRADOR]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/paginas-publicas" element={
                            <RouteGuard
                                routeTo={<PaginasPublicas />}
                                requiredPermissoes={[PermissaoEnum.ADMINISTRADOR]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/admin/recuperar-video" element={
                            <RouteGuard
                                routeTo={<AdminVideoRecoveryPage />}
                                requiredPermissoes={[PermissaoEnum.ADMINISTRADOR]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/siga-dac" element={
                            <RouteGuard
                                routeTo={<SigaDac />}
                                requiredPermissoes={[PermissaoEnum.DAC]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/recursos" element={
                            <RouteGuard
                                routeTo={<SelecionarBancaRecursosPendentes />}
                                requiredPermissoes={[]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="/tecnico/bancas" element={<RouteGuard
                            routeTo={<BancasTecnicoPage />}
                            requiredPermissoes={[]}
                            requiredPerfis={[]}
                        />} />
                        <Route path="/bancas/:bancaId/heteroidentificacao-presidente" element={<RouteGuard
                            routeTo={<VotacaoPresidente />}
                            requiredPermissoes={[PermissaoEnum.ABRIR_VOTACAO]}
                            requiredPerfis={[]}
                            isBancaIdRequired={true}
                        />} />
                        <Route path="/bancas/:bancaId/heteroidentificacao-membro" element={<RouteGuard
                            routeTo={<VotacaoMembro />}
                            requiredPermissoes={[PermissaoEnum.VOTAR_CANDIDATO]}
                            requiredPerfis={[]}
                            isBancaIdRequired={true}
                        />} />
                        <Route path="/bancas/:bancaId/votacao-admin" element={<RouteGuard
                            routeTo={<VotacaoAdmin />}
                            requiredPermissoes={[PermissaoEnum.ADMINISTRADOR]}
                            requiredPerfis={[]}
                        />} />
                        <Route path="processos/:processoId/bancas/:bancaId/inserir-candidatos" element={<RouteGuard
                            routeTo={<VincularCandidatosBanca />}
                            requiredPermissoes={[PermissaoEnum.VINCULAR_CANDIDATO]}
                            isBancaIdRequired={true}
                            requiredPerfis={[]}
                        />} />
                        <Route path="processos/:processoId/bancas/:bancaId/candidatos/videos/upload" element={<RouteGuard
                            routeTo={<CandidatosBancaVideo />}
                            requiredPermissoes={[]}
                            requiredPerfis={[]}
                        />} />
                        <Route path="processos/:processoId/bancas/:bancaId/candidatos" element={<RouteGuard
                            routeTo={<CandidatosBancaPage />}
                            requiredPermissoes={[]}
                            requiredPerfis={[]}
                        />} />
                        <Route path="/changelog" element={<Changelog />} />
                        <Route path="/api-docs" element={<ApiDocsPage />} />
                        <Route index element={
                            <RouteGuard
                                routeTo={<Home />}
                                requiredPermissoes={[]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="processos" element={
                            <RouteGuard
                                routeTo={<ProcessosNova />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_PROCESSO]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="acesso-negado" element={<PaginaAcessoNegado />} />
                        <Route path="usuarios/gerenciar-credenciados" element={
                            <RouteGuard
                                routeTo={<GerenciarPerfis />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_USUARIO]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="usuarios/permissoes-perfis" element={
                            <RouteGuard
                                routeTo={<PermissoesPerfis />}
                                requiredPermissoes={[PermissaoEnum.ADMINISTRADOR]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="pessoas/gerenciar-membros" element={
                            <RouteGuard
                                routeTo={<MembrosCavuPage />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_PESSOA]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="pessoas/gerenciar-externos" element={
                            <RouteGuard
                                routeTo={<ExternosPage />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_PESSOA]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="composicoes" element={
                            <RouteGuard
                                routeTo={<Composicoes />}
                                requiredPermissoes={[]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="composicoes/novo" element={
                            <RouteGuard
                                routeTo={<NovoTemplate />}
                                requiredPermissoes={[]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="composicoes/:id" element={
                            <RouteGuard
                                routeTo={<DetalhesComposicao />}
                                requiredPermissoes={[]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="unidades/cadastrar" element={
                            <RouteGuard
                                routeTo={<UnidadeCadastro user={usuario!} />}
                                requiredPermissoes={[PermissaoEnum.CADASTRAR_UNIDADE]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="unidades/editar" element={
                            <RouteGuard
                                routeTo={<UnidadeEdicao />}
                                requiredPermissoes={[PermissaoEnum.ATUALIZAR_UNIDADE]}
                                requiredPerfis={[]}
                            />
                        } />
                        <Route path="processos/:processoId" element={<RouteGuard
                            routeTo={<ProcessoWrapper />}
                            requiredPermissoes={[PermissaoEnum.CONSULTAR_PROCESSO]}
                            requiredPerfis={[]}
                        />}>
                            <Route path="email-candidatos-heteroidentificacao" element={<RouteGuard
                                routeTo={<EmailCandidatosHeteroidentificacao />}
                                requiredPermissoes={[]}
                                requiredPerfis={[]}
                            />} />
                            <Route path="candidatos/upload" element={
                                <RouteGuard
                                    routeTo={<CandidatosUpload />}
                                    requiredPermissoes={[PermissaoEnum.UPLOAD_CANDIDATO]}
                                    requiredPerfis={[]}
                                />
                            } />
                            <Route path="candidatos" element={
                                <RouteGuard
                                    routeTo={<CandidatosProcesso />}
                                    requiredPermissoes={[PermissaoEnum.CONSULTAR_CANDIDATO]}
                                    requiredPerfis={[]}
                                />
                            } />
                            <Route path="cronograma" element={<RouteGuard
                                routeTo={<PaginaCronograma />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_CRONOGRAMA]}
                                requiredPerfis={[]}
                            />} />
                            <Route path="cronograma/pdf" element={<RouteGuard
                                routeTo={<CronogramaPDF />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_CRONOGRAMA]}
                                requiredPerfis={[]}
                            />} />
                            <Route path="bancas/:bancaId/disponibilidade-banca" element={<RouteGuard
                                routeTo={<ConsultarDisponibilidadeBanca />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_BANCA]}
                                requiredPerfis={[]}
                            />} />
                            <Route path="bancas/:bancaId/definir-membros" element={<RouteGuard
                                routeTo={<DefinirMembrosBanca />}
                                requiredPermissoes={[PermissaoEnum.DEFINIR_BANCA]}
                                requiredPerfis={[]}
                            />} />
                            <Route path="bancas/:bancaId/composicao" element={<RouteGuard
                                routeTo={<ComposicaoBancaDetalhada />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_BANCA]}
                                requiredPerfis={[]}
                            />} />
                            <Route path="sala-espera" element={<RouteGuard
                                routeTo={<DefinirSalaEspera />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_SALA_ESPERA]}
                                requiredPerfis={[]}
                            />} />
                            <Route path="bancas" element={<RouteGuard
                                routeTo={<Bancas />}
                                requiredPermissoes={[PermissaoEnum.CONSULTAR_BANCA]}
                                requiredPerfis={[]}
                            />} />
                        </Route>
                    </Route>

                    {/* Rota catch-all para URLs não encontradas */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BreadcrumbProvider>
            <ToastContainer
                position="top-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                toastClassName="custom-toast"
            />
        </Router>
    );
};

export default AppRouter;
